<template>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template>
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        <img class="n-logo" src="https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/cloudct-logo.png" alt="" />
        <label class="d-sm-none">Cloud CT</label>
      </router-link>
      <!-- <el-popover
        ref="popover1"
        popper-class="popover"
        placement="bottom"
        width="250"
        trigger="hover"
      >
        <div class="popover-body">
          
        </div>
      </el-popover> -->
    </template>
    <template slot="navbar-menu">
      <!-- <li class="nav-item">
        <a
          class="nav-link"
          href="https://www.creative-tim.com/product/vue-now-ui-kit"
          target="_blank"
        >          
          <p>Consultoria Cloud</p>
        </a>
      </li> -->
      <!-- <li class="nav-item">
        <a
          class="nav-link"
          href="https://www.creative-tim.com/product/vue-now-ui-kit"
          target="_blank"
        >
          <p>Treinamentos</p>
        </a>
      </li> -->
      <!-- <drop-down
        tag="li"
        title="Components"
        icon="now-ui-icons design_app"
        class="nav-item"
      >
        <nav-link to="/">
          <i class="now-ui-icons business_chart-pie-36"></i> All components
        </nav-link>
        <a
          href="https://demos.creative-tim.com/vue-now-ui-kit/documentation"
          target="_blank"
          class="dropdown-item"
        >
          <i class="now-ui-icons design_bullet-list-67"></i> Documentation
        </a>
      </drop-down> -->
      <!-- <drop-down
              tag="li"
              title="Cursos"
              class="nav-item"
      >
        <nav-link to="/landing">
          <i class="now-ui-icons education_paper"></i> Deploy AWS
        </nav-link>
        <nav-link to="/login">
          <i class="now-ui-icons users_circle-08"></i> Login
        </nav-link>
        <nav-link to="/profile">
          <i class="now-ui-icons users_single-02"></i> Profile
        </nav-link>
      </drop-down>  -->
      
      <!-- <li class="nav-item">
        <a
          class="nav-link btn btn-neutral"
          href="https://www.creative-tim.com/product/vue-now-ui-kit-pro"
          target="_blank"
        >
          <i class="now-ui-icons arrows-1_share-66"></i>
          <p>Upgrade to PRO</p>
        </a>
      </li> -->

      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Chame no Whatsapp"
          data-placement="bottom"
          href="https://api.whatsapp.com/send?phone=+5543991604144&amp;text=Olá%21%20Gostaria%20de%20informações%20sobre%20a%20Cloud%20CT."
          target="_blank"
        >
          <i class="fab fa-whatsapp"></i>
          <p class="d-lg-none d-xl-none">Whatsapp</p>
        </a>
      </li>

      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Baixe nossas imagens públicas no Docker"
          data-placement="bottom"
          href="https://hub.docker.com/u/cloudct"
          target="_blank"
        >
        <i class="fab fa-docker"></i>
          <p class="d-lg-none d-xl-none">Docker</p>
        </a>
      </li>

      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Nos dê uma estrela no Github!"
          data-placement="bottom"
          href="https://github.com/cloud-ct"
          target="_blank"
        >
        <i class="fab fa-github"></i>
          <p class="d-lg-none d-xl-none">Github</p>
        </a>
      </li>
      
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Siga no Instagram"
          data-placement="bottom"
          href="https://www.instagram.com/coding_tironi"
          target="_blank"
        >
          <i class="fab fa-instagram"></i>
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
import { Navbar, /*DropDown, NavLink*/ } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    Navbar,
    /*DropDown,
    NavLink,*/
    [Popover.name]: Popover
  }
};
</script>

<style scoped></style>
